export const SET_COUNT = 'SETTINGS_DISPLAY_SET_COUNT'
export const CLEAR_COUNT = 'SETTINGS_DISPLAY_CLEAR_COUNT'



// WEBPACK FOOTER //
// ./src/features/Settings/data/display/constants.js